<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Service_Name">Service Name</label>
              <input
                myFocus
                type="text"
                name="Service_Name"
                [(ngModel)]="dsCollection.criteria.Service_Name"
                ngControl="Service_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <unity-button-old
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              type="button"
              (click)="dsCollection.criteria.Service_Name = ''; model.dirty = true"
              classes="secondary"
              style="margin-top: 16px"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #serviceFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header">
            <tr *ngIf="dsCollection.objectNodes && dsCollection.objectNodes.length > 0">
              <th>Service Name</th>
              <th>Service Desc</th>
            </tr>
            <tr
              *ngFor="
                let service of dsCollection.objectNodes
                  | epFilter : serviceFilter.filter : serviceFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(service)"
            >
              <td>
                {{ service.Service_Name }}
              </td>
              <td>
                {{ service.Service_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Services</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
